import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { type Xinglet } from '@xing-com/crate-xinglet';

import ArticlesPageWrapper from './components/articles-page-wrapper';
import { LoggedInRouter, LoggedOutRouter } from './components/routers';

export default class Entry implements Xinglet {
  public getComponent() {
    return (): JSX.Element => {
      const { isLoggedOut } = useLoginState();

      return (
        <ArticlesPageWrapper>
          {isLoggedOut ? <LoggedOutRouter /> : <LoggedInRouter />}
        </ArticlesPageWrapper>
      );
    };
  }
}
